module.exports = __webpack_public_path__ + "img/almatyObl4.a0288fb1.jpg";